import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useIntervalOption, useWidgets } from 'modules/Dashboard/Widgets/Hooks';
import { useActiveUsers } from 'modules/Dashboard/Widgets/Users/Hooks';

import { ActiveUsers } from './ActiveUsers.component';
import { UsersWidgetPlaceholder } from 'modules/Dashboard/Widgets/Users/Common';
import { WidgetSettings } from 'modules/Dashboard/Widgets/Common';
import { MOCKED_DATA } from 'modules/Dashboard/Widgets/Users/UserWidgets.utils';

export const ActiveUsersContainer = ({ widget, isMock }) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const { intervalOption, setIntervalOption } = useIntervalOption({
    defaultOption: widget?.settings?.default_option || '7',
  });

  const { fetchActiveUsers, activeUsers } = useActiveUsers();
  const { saveWidgetSettings, removeActiveWidget } = useWidgets();

  useEffect(() => {
    if (isMock) return;

    fetchActiveUsers(intervalOption);
  }, []);

  const handleChangeIntervalOption = (option) => {
    if (isMock) return;

    setIntervalOption(option);
    fetchActiveUsers(option);
  };

  if (activeUsers?.loading) {
    return <UsersWidgetPlaceholder widget={widget} />;
  }

  if (isSettingsOpen) {
    return (
      <WidgetSettings
        widget={widget}
        onSave={saveWidgetSettings}
        onClose={() => setIsSettingsOpen(false)}
        onRemoveWidget={removeActiveWidget}
      />
    );
  }

  return (
    <ActiveUsers
      widget={widget}
      data={isMock ? MOCKED_DATA : activeUsers?.data}
      intervalOption={intervalOption}
      onChangeIntervalOption={handleChangeIntervalOption}
      onOpenSettings={() => setIsSettingsOpen(true)}
      isMock={isMock}
    />
  );
};

ActiveUsersContainer.propTypes = {
  widget: PropTypes.object,
  isMock: PropTypes.bool,
};
